export const ON_DRAG_END_DELAY = 1000;

export const SCORE_DELAY = 1000;

export const PLAYER_SEARCH_DELAY = 500;

export const DETAILS_DELAY = 1000;

export const SUCCESS_DELAY = 3000;

export const INPUT_SAVE_ICON_DELAY = 500;

export const POINTS_FOR_WIN = 3;

export const POINTS_FOR_DRAW = 1;

export const INDEX_TO_COURT_NAME = {
  0: "A",
  1: "B",
  2: "C",
  3: "D",
  4: "E",
  5: "F",
  6: "G",
};

export const SaveStatuses = {
  Error: "error",
  Loading: "loading",
  Null: null,
  Success: "success",
};
